import * as yup from 'yup';
import { Axios, MutationConfig } from '@helpers';
import { useMutation, useQueryClient } from 'react-query';
import { getSocialMediaLinksQueryOptions } from './get-social-links';

export const editMultipleSocialMediaLinkInputSchema = yup.object({
  platform: yup.string().nullable(),
  category: yup.string().nullable(),
  postType: yup.string().nullable(),
  caseState: yup.string().nullable(),
  complianceStatus: yup.string().nullable(),
});

export type EditMultipleSocialMediaLinkInput = {
  platform?: string | null;
  category?: string | null;
  postType?: string | null;
  caseState?: string | null;
  complianceStatus?: string | null;
  detectionDate?: string | null;
};

export const editMultipleSocialMediaLink = ({
  data,
  modelId,
}: {
  data: EditMultipleSocialMediaLinkInput;
  modelId: string;
}) => {
  return Axios.patch(`/admin/models/${modelId}/social-media-links`, data);
};

type UseEditMultipleSocialMediaLinksOptions = {
  mutationConfig?: MutationConfig<typeof editMultipleSocialMediaLink>;
};

export const useEditMultipleSocialMediaLinks = ({
  mutationConfig,
}: UseEditMultipleSocialMediaLinksOptions = {}) => {
  const { onSuccess, ...restConfig } = mutationConfig || {};
  const queryClient = useQueryClient();

  return useMutation({
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: getSocialMediaLinksQueryOptions().queryKey,
      });
      onSuccess?.(...args);
    },
    ...restConfig,
    mutationFn: editMultipleSocialMediaLink,
  });
};
